import Vue from 'vue'
import VueRouter from 'vue-router'
import GuessTheMovie from '../views/GuessTheMovie.vue'
import Inspiration from '../views/Inspiration.vue'
// import ZenQuotes from '../views/ZenQuotes.vue'
import ProgrammingJokes from '../views/ProgrammingJokes.vue'
import DadJokes from '../views/DadJokes.vue'

Vue.use(VueRouter)

export const routes = [
    {
        path: '/',
        name: 'Guess the Movie',
        icon: 'mdi-comment-question',
        component: GuessTheMovie
    },
    // {
    //     path: '/quotes/:id',
    //     name: 'Quotes',
    //     props: true,
    //     component: RandomQuote
    // },
    {
        path: '/inspiration',
        name: 'Inspiration',
        icon: 'mdi-heart',
        component: Inspiration
    },
    // todo: fix zen quotes page with try/catch to the API, and error handling
    // {
    //     path: '/zen',
    //     name: 'Zen',
    //     icon: 'mdi-leaf',
    //     component: ZenQuotes,
    // },
    {
        path: '/programming-jokes',
        name: 'Programming Jokes',
        icon: 'mdi-desktop-classic',
        component: ProgrammingJokes,
    },
    {
        path: '/dad-jokes',
        name: 'Dad Jokes',
        icon: 'mdi-account-tie',
        component: DadJokes,
    },
    /*
      {
        path: '/about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/!* webpackChunkName: "about" *!/ '../views/About.vue')
      }
      */
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router;
